import { Row, Col } from '@ag1/ui';
import {
  EduArticlePortableTextProps,
  EduArticleTableOfContentsProps,
  FullEduHubArticleResult
} from 'types/studio/eduHub';
import { EduArticleImage } from './EduArticleImage';
import { EduArticlePortableText } from './EduArticlePortableText';
import { EduArticlesQuote } from './EduArticlesQuote';
import { EduArticleProductHighlight } from './EduArticleProductHighlight';
import styles from './EduArticleBody.module.scss';
import { EduArticleTableOfContents } from './EduArticleTableOfContents/EduArticleTableOfContents';
import EduArticleEmailSubscription from './EduArticleEmailSubscription/EduArticleEmailSubscription';
import { EduArticleKeyTakeaways } from './EduArticleKeyTakeaways/EduArticleKeyTakeaways';
import { EduArticleSources } from './EduArticleSources/EduArticleSources';
import { EduArticlesExperts } from './EduArticlesExperts';

interface Props {
  content: NonNullable<FullEduHubArticleResult['content']>;
}

export const EduArticleBody = ({ content }: Props) => (
  <Row>
    <Col className={styles.content}>
      {content.map((item) => {
        const { _type: type, _key: key } = item;
        switch (type) {
          case 'eduPortableText':
            return <EduArticlePortableText {...(item as EduArticlePortableTextProps)} key={key} />;
          case 'imageSign':
            return <EduArticleImage {...item} key={key} />;
          case 'quote':
            return <EduArticlesQuote {...item} key={key} />;
          case 'tableOfContents':
            return (
              <EduArticleTableOfContents {...(item as EduArticleTableOfContentsProps)} key={key} />
            );
          case 'articleEmailSubscription':
            return <EduArticleEmailSubscription {...item} key={key} />;
          case 'articleProductHighlight':
            return <EduArticleProductHighlight {...item} key={key} />;
          case 'articleKeyTakeaways':
            return <EduArticleKeyTakeaways {...item} key={key} />;
          case 'articleSources':
            return <EduArticleSources {...item} key={key} />;
          case 'articleExperts':
            return <EduArticlesExperts {...item} key={key} />;
          default:
            return null;
        }
      })}
    </Col>
  </Row>
);
